/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  class CartUpsellSlider extends HTMLElement {
    constructor() {
      super();
      this.flkty = null;
    }

    connectedCallback() {
      if (this.flkty || !this.closest(".cart-block-upsell-slider")) return;

      const track = this.querySelector(".cart-block-upsell-slider__track");
      if (!track) return;

      this.flkty = new window.themeVendor.Flickity(track, {
        cellAlign: "left",
        contain: true,
        groupCells: false,
        pageDots: true,
        wrapAround: false,
        prevNextButtons: false,
        imagesLoaded: true,
        draggable: true,
      });
    }

    disconnectedCallback() {
      if (!this.flkty) return;

      this.flkty.destroy();
      this.flkty = null;
    }
  }

  if (!customElements.get("cart-upsell-slider")) {
    customElements.define("cart-upsell-slider", CartUpsellSlider);
  }

  class ModalOpener extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", () => {
        const modal = document.querySelector(this.getAttribute("data-modal"));
        if (modal) modal.show(this);
      });
    }
  }
  customElements.define("modal-opener", ModalOpener);

  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this, false),
      );
      this.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() === "ESCAPE") this.hide();
      });

      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }

    show(opener) {
      this.openedBy = opener;
      document.body.classList.add("overflow-hidden");
      this.setAttribute("open", "");
    }

    hide() {
      document.body.classList.remove("overflow-hidden");
      this.removeAttribute("open");
    }
  }
  customElements.define("modal-dialog", ModalDialog);

  var VideoSellDialog = class extends ModalDialog {
    constructor() {
      super();
      this.coming_btn = this.querySelectorAll(".show-coming");
      this.coming = this.querySelector(
        ".sell-content-section .coming-container",
      );
      this.closeComingBtn = this.querySelector("#comingCloseButton");
      this.contentProducts = this.querySelectorAll(
        ".sell-content-section .sproduct-card",
      );
      this.closeBtn = this.querySelector("#goBackButton");
      this.video = this.querySelector("video");
      this.videoBtn = this.querySelector("#soundToggler");
      this.init();
    }

    init() {
      this.coming_btn.forEach((btn) => {
        btn.addEventListener("click", () =>
          this.coming.classList.toggle("active"),
        );
      });
      this.closeComingBtn.addEventListener("click", () =>
        this.coming.classList.remove("active"),
      );
      this.closeBtn.addEventListener("click", () => this.hide());
      this.videoBtn.addEventListener("click", () => this.playVideo());
      this.contentProducts.forEach((pr) => {
        pr.addEventListener("click", (e) => {
          if (!e.target.classList.contains("sproduct-card__link")) {
            pr.classList.toggle("collapsed");
          }
        });
      });
    }
    playVideo() {
      if (this.hasAttribute("playing")) {
        this.video.pause();
        this.coming.classList.add("active");
        return this.removeAttribute("playing");
      }
      this.video.play();
      this.coming.classList.remove("active");
      return this.setAttribute("playing", true);
    }
    show(opener) {
      const modals = document.querySelectorAll("video-sell-dialog");
      modals.forEach((m) => m.hide());
      this.openedBy = opener;
      document.body.classList.add("overflow-hidden");
      this.setAttribute("open", "");
    }
    hide() {
      this.video.pause();
      this.coming.classList.add("active");
      this.removeAttribute("playing");
      super.hide();
    }
  };
  customElements.define("video-sell-dialog", VideoSellDialog);

  if (!customElements.get("faq-items")) {
    customElements.define(
      "faq-items",
      class FaqItems extends HTMLElement {
        constructor() {
          super();

          this.items = this.querySelectorAll(".section-faq-item");

          this.items.forEach(this.addEventOnClick.bind(this));
          this.items.forEach(this.removeEventOnClickOnChildren.bind(this));
        }

        /**
         *
         * @param {HTMLElement} item
         */
        addEventOnClick(item) {
          const self = this;
          item.addEventListener("click", function (e) {
            self.hideAllItems(this);
            if (!this.hasAttribute("open")) {
              this.querySelector(".section-faq-item-content").style.height =
                this.querySelector(
                  ".section-faq-item-content-body",
                ).getBoundingClientRect().height + "px";
              this.setAttribute("open", "1");
            } else {
              this.querySelector(".section-faq-item-content").style.height =
                "0";
              this.removeAttribute("open");
            }
          });
        }

        /**
         *
         * @param {HTMLElement} item
         */
        removeEventOnClickOnChildren(item) {
          const self = this;
          item
            .querySelector(".section-faq-item-content")
            .addEventListener("click", function (e) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
            });
        }

        /**
         *
         * @param {HTMLElement} item
         */
        hideAllItems(item) {
          this.items.forEach((current_item) => {
            if (item != current_item) {
              current_item.querySelector(
                ".section-faq-item-content",
              ).style.height = "0";
              current_item.removeAttribute("open");
            }
          });
        }
      },
    );
  }

  // Backup the original browser functions
  const originalAssign = window.location.assign;
  const originalReplace = window.location.replace;
  function openCartDrawer() {
    const cartDrawer = document.querySelector(selectors$t.cartDrawer);
    if (cartDrawer) {
      e.preventDefault();
      cartDrawer.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
    }
  }

  // Intercept window.location.assign()
  window.location.assign = function (url) {
    if (url.includes("/cart")) {
      console.log("Intercepted app redirect via assign!");
      openCartDrawer(); // Trigger your drawer here
      return; // Stop the redirect
    }
    originalAssign.apply(window.location, arguments);
  };

  // Intercept window.location.replace()
  window.location.replace = function (url) {
    if (url.includes("/cart")) {
      console.log("Intercepted app redirect via replace!");
      openCartDrawer(); // Trigger your drawer here
      return; // Stop the redirect
    }
    originalReplace.apply(window.location, arguments);
  };
})();

// GIFT PRODUCT SYSTEM
/**
 * Multi-tier free gift system for Shopify carts.
 *
 * Register any number of { threshold, variantId } pairs. On every cart
 * change, this recalculates which gifts should be present and adds/removes
 * them with a single batched request each way.
 *
 * IMPORTANT: this only manages which gift *lines* are in the cart.
 * You still need a Shopify Function (cart/checkout discount) that reads the
 * `_free_gift` line item property (or matches on variant ID) and applies a
 * 100% discount, otherwise the customer will be charged for these items.
 */

(function () {
  if (!window || !window.Shopify) return;

  const CartEvents = {
    add: "SCE:add",
    update: "SCE:update",
    change: "SCE:change",
    clear: "SCE:clear",
    mutate: "SCE:mutate",
  };

  const ShopifyCartURLs = [
    "/cart/add",
    "/cart/update",
    "/cart/change",
    "/cart/clear",
    "/cart/add.js",
    "/cart/update.js",
    "/cart/change.js",
    "/cart/clear.js",
  ];

  function isShopifyCartURL(url) {
    if (!url) return false;
    const path = url.split("/").pop();
    return ShopifyCartURLs.includes(`/cart/${path}`);
  }

  function updateType(url) {
    if (!url) return false;
    if (url.includes("cart/add")) {
      return "add";
    } else if (url.includes("cart/update")) {
      return "update";
    } else if (url.includes("cart/change")) {
      return "change";
    } else if (url.includes("cart/clear")) {
      return "clear";
    } else return false;
  }

  function dispatchEvent(url, detail) {
    if (typeof detail === "string") {
      try {
        detail = JSON.parse(detail);
      } catch {}
    }

    window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
    const type = updateType(url);
    switch (type) {
      case "add":
        window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
        break;
      case "update":
        window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
        break;
      case "change":
        window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
        break;
      case "clear":
        window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
        break;
      default:
        break;
    }
  }

  function XHROverride() {
    if (!window.XMLHttpRequest) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function () {
      const url = arguments[1];
      this.addEventListener("load", function () {
        if (isShopifyCartURL(url)) {
          dispatchEvent(url, this.response);
        }
      });
      return originalOpen.apply(this, arguments);
    };
  }

  function fetchOverride() {
    if (!window.fetch || typeof window.fetch !== "function") return;
    const originalFetch = window.fetch;
    window.fetch = function () {
      const response = originalFetch.apply(this, arguments);

      if (isShopifyCartURL(arguments[0])) {
        response.then((res) => {
          res
            .clone()
            .json()
            .then((data) => dispatchEvent(res.url, data));
        });
      }

      return response;
    };
  }

  fetchOverride();
  XHROverride();
})();

(function () {
  function initEvents() {
    window.addEventListener("SCE:add", (event) => {
      syncGifts(true);
    });
    window.addEventListener("SCE:update", (event) => {
      syncGifts(true);
    });
    window.addEventListener("SCE:change", (event) => {
      syncGifts(true);
    });
  }

  const FREE_GIFT_PROPERTY_KEY = "_free_gift";
  // ------------------------------------------------------------------------

  let isSyncing = false; // reentrancy guard so our own add/change calls don't recurse

  function isGiftLine(item) {
    return (
      item.properties && item.properties[FREE_GIFT_PROPERTY_KEY] === "true"
    );
  }

  function giftLinesByVariant(cart) {
    const map = new Map();
    cart.items.forEach((item) => {
      if (isGiftLine(item)) map.set(item.variant_id, item);
    });
    return map;
  }

  function nonGiftSubtotal(cart) {
    return cart.items
      .filter((item) => !isGiftLine(item))
      .reduce((sum, item) => sum + item.line_price, 0);
  }

  async function syncGifts(open = false) {
    if (isSyncing) return;

    const cart = await getCart();
    if (!cart) return;

    const GIFT_RULES = window.GIFT_RULES;
    const subtotal = nonGiftSubtotal(cart);
    const currentGifts = giftLinesByVariant(cart);

    const toAdd = [];
    const updates = {}; // keyed by line item key, value = quantity (0 removes)

    for (const rule of GIFT_RULES) {
      const qualifies = subtotal >= rule.threshold;
      const existingLine = currentGifts.get(rule.variantId);

      if (qualifies && !existingLine) {
        toAdd.push({
          id: rule.variantId,
          quantity: 1,
          properties: { [FREE_GIFT_PROPERTY_KEY]: "true" },
        });
      } else if (!qualifies && existingLine) {
        updates[existingLine.key] = 0;
      }
    }

    if (toAdd.length === 0 && Object.keys(updates).length === 0) {
      return; // nothing to do
    }

    isSyncing = true;
    try {
      // Removals first, so a gift downgraded to a lower/no tier doesn't
      // briefly coexist with a new one if variant IDs were ever reused.
      if (Object.keys(updates).length > 0) {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        });
      }

      if (toAdd.length > 0) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: toAdd }),
        });
      }

      // Re-fetch and re-run in case the add/remove itself changed the
      // subtotal in a way that flips another tier (e.g. removing a gift
      // that was inflating subtotal due to a pricing edge case).
      const cartItems = document.querySelector("cart-items");
      cartItems?.getCart();

      if (open) {
        document.dispatchEvent(
          new CustomEvent("theme:product:added", { bubbles: true }),
        );
      }
    } catch (err) {
      console.error("Free gift sync failed:", err);
    } finally {
      isSyncing = false;
    }
  }
  async function getCart() {
    const result = await fetch("/cart.json");

    if (result.status === 200) {
      return result.json();
    }

    throw new Error(
      `Failed to get request, Shopify returned ${result.status} ${result.statusText}`,
    );
  }
  initEvents();
  syncGifts();
})();
